import { Navigate, Route, Routes } from 'react-router-dom';

import FrameDetailsPage from 'features/Frames/pages/FrameDetailsPage/FrameDetailsPage';
import FramesPage from 'features/Frames/pages/FramesPage/FramesPage';
import HealthPage from 'features/Health/pages/HealthPage/HealthPage';
import SearchPage from 'features/Search/pages/SearchPage';
import { FRAMES_PAGE_URL, HEALTH_PAGE_URL, SEARCH_PAGE_URL } from 'utils/defaults';

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Navigate to={HEALTH_PAGE_URL} />} />
    <Route path={HEALTH_PAGE_URL} element={<HealthPage />} />
    <Route path={FRAMES_PAGE_URL} element={<FramesPage />} />
    <Route path={SEARCH_PAGE_URL} element={<SearchPage />} />
    <Route path={`${FRAMES_PAGE_URL}/:frameId`} element={<FrameDetailsPage />} />
    <Route path="*" element={<Navigate to={HEALTH_PAGE_URL} state={{ invalidUrl: true }} />} />
  </Routes>
);

export default AppRoutes;
